import React from 'react';
import { connect } from 'react-redux';

export default function clickUser(ComposedComponent) {
  function ClickUser(props, state) {
    const { auth } = props;
    const isAuthenticated = auth ? true : false;
    return (
      <ComposedComponent
        {...props}
        {...state}
        isAuthenticated={isAuthenticated}
      />
    );
  }
  function mapStateToProps(state) {
    return { auth: state.auth.authenticated };
  }
  return connect(mapStateToProps, null)(ClickUser);
}
